import { UppFloorPlanVertex, type UppFloorPlanElement } from '../plan/floor-plan-element';

/** `MouseEvent.detail` when reliable; otherwise `0` (Konva often passes pointerup without click detail). */
export function floorPlanPointerEventClickDetail(domEv: MouseEvent | PointerEvent): number {
  const d = (domEv as MouseEvent).detail;
  return typeof d === 'number' && Number.isFinite(d) ? d : 0;
}

/** Edit-mode selection: treat invalid detail as single-click (`1`). */
export function floorPlanEditModeClickDetail(domEv: MouseEvent | PointerEvent): number {
  const detailRaw = (domEv as MouseEvent).detail;
  return typeof detailRaw === 'number' && Number.isFinite(detailRaw) && detailRaw >= 1
    ? Math.floor(detailRaw)
    : 1;
}

export function vertexContinueDrawWithinTapWindow(
  vertexId: string,
  now: number,
  lastId: string,
  lastAt: number,
  windowMs: number,
): boolean {
  return lastId === vertexId && now - lastAt <= windowMs;
}

export function vertexContinueDrawShouldEmit(detail: number, withinTapWindow: boolean): boolean {
  return detail >= 2 || withinTapWindow;
}

/** First click on a vertex in wall-chain draw mode: keep Konva node instance for second tap. */
export function floorPlanPreserveSelectionRedrawForVertexContinueTap(
  detail: number,
  roomBackgroundPointerMode: 'none' | 'doubleClickRoomCm',
  el: UppFloorPlanElement,
): boolean {
  return (
    detail === 1 && roomBackgroundPointerMode === 'doubleClickRoomCm' && el instanceof UppFloorPlanVertex
  );
}
